import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=3f9f540f&scoped=true&lang=pug"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"
import style0 from "./Blocks.styl?vue&type=style&index=0&id=3f9f540f&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9f540f",
  null
  
)

export default component.exports